import axios from 'axios';
import { API_CONFIG } from '../config/api.js';

class TrainingSetService {
  static async getTrainingSets(page = 1, perPage = 20, label = '', set = 'Ai') {
    try {
      const params = {
        page: page,
        per_page: perPage,
        set: set
      };

      if (label) {
        params.label = label;
      }

      const response = await axios.get(`${API_CONFIG.BASE_URL}/training-sets`, {
        params,
        withCredentials: true
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Failed to fetch training sets:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch training sets'
      };
    }
  }
}

export default TrainingSetService;
